import { InputText } from "primereact/inputtext";
import { Controller } from "react-hook-form";

// Types
import { ICommonProps } from "../types";

export function AddressTerrain({control,formState,setValue}: ICommonProps<any, any, any,any>) {
    return ( <span className="md:flex-1 max-sm:w-full md:min-w-[48%] md:max-w-[50%] flex flex-col gap-2 border-b-[1px] border-gray-300">
            <label htmlFor="">Endereço completo do terreno com CEP</label>
            <span data-haserrors={formState?.errors?.address_terrain?.message && true}
                className="hidden data-[haserrors=true]:flex text-red-400 text-sm">{formState?.errors?.address_terrain?.message}</span>
            <Controller
                control={control}
                name="address_terrain"
                render={({
                    field,
                }) => (
                    <InputText
                        {...field}
                        placeholder="Digite o endereço do condominio"
                        className="w-full !bg-transparent !border-none  !rounded-none"
                    />
                )}
            />
        </span>
    )
}